import React from 'react'
import LinkChooser from '../links/linkChooser'

import s from "./cards.module.css"

const imageType=(type)=>{
  if(type === 'icon' ){
    return s.icon
  }
  else if(type === 'fullWidth' ){
    return s.fullWidth
  }
  else if(type === 'fullHeight' ){
    return s.fullHeight
  }
}

const WithLink = (props) => (
  props.to ?
  <LinkChooser {...props} >
    {props.children}
  </LinkChooser>
  : <div {...props}>{props.children}</div>
);

const Card = (props) => (
  <WithLink
    onClick={props.onClick}
    to={props.link}
    className={`${props.className} ${imageType(props.imageType)} ${s.card} ${props.link ? s.card_isLink : ''}`}>
    {
      props.img ? 
      <div className={ `${props.imageProportion === 'vertical' ? s.imageVertical : ''} ${s.imageContainer}`}>
        <img src={props.img} alt='' className={`${s.image}`}/>
      </div>
        : null
    }
    <div className={s.content}>
      {
        props.title ?
        <p className={`${s.title}`}>
          {props.title}
        </p> : null
      }
      <div className={s.children}>
        {props.children}
      </div>
      {
        props.link ? 
          <p className='fw-1 c-orange-0'>{props.linkLabel || 'Ver más'}</p> :
          null
      }
    </div>
  </WithLink>
)


Card.defaultProps = {
  className: '',
  imageType: 'fullWidth',
  imageProportion: 'horizontal',
  link:'',
  linkLabel: 'Ver más'
};

export default Card
